import NoImageSmall from "assets/Images/no_image_card.webp"
export function FallbackObj() {
    var obj = { fallback: "" };
    obj.fallback = NoImageSmall
  
    return obj;
  }